export default "__VITE_ASSET__DUk9sp16__"